---
nb:
  admin:
    time_series_trackers:
      by_source:
        ago: for {time} siden
        columns:
          latest_reading: Siste kjente avlesning
          plants: Anlegg
          source: Kilde
          status: Status
        load_error: Kunne ikke laste kildestatus.
        never: Aldri
        no_plants: Ingen aktive anlegg er konfigurert for denne kilden.
        no_sources: Ingen kilder funnet.
        plant_columns:
          latest_reading: Siste avlesning
          plant: Anlegg
          signal: Signal
          status: Status
        refresh: Oppdater
        search_placeholder: Søk etter et kraftverk
        show_empty: Vis kilder uten anlegg
        signal:
          all: Alle signaler
          heartbeat: Sensorpuls
          volume: Volum
        status:
          delayed: Forsinket
          down: Nede
          no_data: Ingen data
          up: Oppe
        subtitle: Om hver aktive datakilde rapporterer eller har blitt borte.
        title: Datakildestatus
      tabs:
        by_series: Per serie
        by_source: Per kilde
